import React from 'react'

import Navbar from '../../Components/Navbar/Navbar';
import Footer from '../../Components/Footer/Footer';

import { ADMIN_USER_TYPE, STUDENT_USER_TYPE } from '../../services/UserService';

import { useParams } from 'react-router-dom';
import ZoomView from '../../Components/Zoom/ZoomView';
import ZoomIframeView from '../../Components/Zoom/ZoomIframeView'
import LiveStreamIframeView from '../../Components/Zoom/LiveStreamIframeView';

const StudentLiveStream = () => {
    const { slotId } = useParams();
    return (
        <>
            {/* <Hero
                cName="hero"
                img={image}
                title="Live Class"
                description="Engage and Motivate Yourself with JEETA!"
            /> */}
            <LiveStreamIframeView slotId={parseInt(slotId)} user={STUDENT_USER_TYPE} />
        </>
    )
};

export default StudentLiveStream;